import Spinner from "@wds/blocks/common/Spinner";

const Button = ({
	children,
	onClick,
	className,
	type = 'button',
	isLoading = false,
	isDisabled = false
}) => {
	return (
		<button
			type={type}
			className={`wds-popup__button ${className ? className : ''}`}
			onClick={onClick}
			disabled={isDisabled}>
			<div className="wds-popup__button-content">
				{children}
			</div>
			<div className="wds-popup__button-spinner">
				{isLoading && <Spinner width={20} />}
			</div>
		</button>
	);
};

export default Button;